export default "__VITE_PUBLIC_ASSET__35475713__"